export const FETCH_DATA = 'fetchData';